import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { initSentry } from './lib/sentry'
import './styles/index.css'
import './styles/global.css'

/**
 * Mark the document when this is the app rather than a browser tab.
 *
 * Lets CSS switch off behaviours that belong to a browser and not to an app —
 * see `.app-shell` in styles/global.css. Set before render so nothing paints
 * with the wrong behaviour first.
 */
import { isOurApp, isStandalone } from './lib/platform'
if (isOurApp() || isStandalone()) {
  document.documentElement.classList.add('app-shell')
}

// Before anything renders, so errors during the first paint are captured too.
// No-ops when VITE_SENTRY_DSN is unset.
initSentry()

// Ensure the root element has proper styles
const rootElement = document.getElementById('root')
if (rootElement) {
  rootElement.style.backgroundColor = '#0a0a0b' // neutral-950 (DESIGN_SYSTEM.md surface.DEFAULT)
  rootElement.style.color = '#fafafa'
  rootElement.style.minHeight = '100vh'
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
